export const messages = {
  labels: {
    testDate: {
      id: 'treatmentSummary.Groups.GeneticTest.TestDate',
      defaultMessage: 'Date: ',
    },
    testSummary: {
      id: 'treatmentSummary.Groups.GeneticTest.TestSummary',
      defaultMessage: 'Summary: ',
    },
    testDetail: {
      id: 'treatmentSummary.Groups.GeneticTest.TestDetail',
      defaultMessage: 'Detail: ',
    },
    patientCounseling: {
      id: 'treatmentSummary.Groups.GeneticTest.PatientCounseling',
      defaultMessage: 'Patient Counseling: ',
    },
    providerName: {
      id: 'treatmentSummary.Groups.GeneticTest.ProviderName',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.GeneticTest.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.GeneticTest.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.GeneticTest.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.GeneticTest.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
